import React from 'react';
import Radium from 'radium';

const styles = {
	mainButton: {
		cursor: 'pointer',
		display: 'inline-block',
		minHeight: '1em',
		outline: 0,
		border: '1px solid #5f9be0',
		verticalAlign: 'baseline',
		backgroundColor: '#5f9be0',
		color: '#fff',
		fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
		margin: '0 .25em 0 0',
		padding: '.78571429em 1em .78571429em',
		textTransform: 'none',
		textShadow: 'none',
		fontWeight: 700,
		lineHeight: '1em',
		fontStyle: 'normal',
		textAlign: 'center',
		textDecoration: 'none',
		borderRadius: '.28571429rem',
		boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
		transition:
			'opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease',
		':hover': {
			backgroundColor: '#5e92d6',
			boxShadow:
				'0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
			color: '#f5f5f5',
		},
		':active': {
			backgroundColor: '#5e83c7',
			color: '#e6e6e6',
		},
	},
};

const SecondaryButton = ({ text, type, style, onClick, children }) => {
	return (
		<button
			style={{ ...styles.mainButton, ...style }}
			type={type}
			onClick={(e) => {
				if (onClick !== undefined) {
					e.preventDefault();
					onClick();
				}
			}}
		>
			{text} {children}
		</button>
	);
};

export default Radium(SecondaryButton);
